import type { LoopRecordListActionGroupConfig } from "@smartsuite/automation-engine-api";
import { recordListConfigFrom } from "@smartsuite/automation-conditions";
import type { RecordsSourceOption } from "../utils";
import type {
  ActionCandidate,
  TriggerCandidate,
} from "../../../../../../types/candidate";
import { ActionLabel } from "../../../../../../utils/constants";
import {
  isLoopingOutputAction,
  isLoopingOutputTrigger,
  isSingleFindRecordsAction,
} from "../utils";

export const getSourceDataFromOption = (
  option: RecordsSourceOption,
  trigger: TriggerCandidate,
  actions: ActionCandidate[],
): LoopRecordListActionGroupConfig["source"] | undefined => {
  switch (option.type) {
    case "trigger":
      if (
        trigger.triggerReference !== undefined &&
        isLoopingOutputTrigger(trigger)
      )
        return {
          oneofKind: "outputReference",
          outputReference: {
            source: {
              oneofKind: "triggerReference",
              triggerReference: trigger.triggerReference,
            },
            outputId: "",
          },
        };
      break;
    case "action": {
      if (option.actionReference === undefined) {
        return undefined;
      }
      const currentAction = actions.find((action) => {
        return (
          option.actionReference?.instanceId ===
          action.actionReference?.instanceId
        );
      });
      if (currentAction === undefined) {
        return undefined;
      }
      if (currentAction.actionReference?.actionId === ActionLabel.findRecords) {
        if (isSingleFindRecordsAction(currentAction)) {
          return {
            oneofKind: "outputReference",
            outputReference: {
              outputId: "",
              source: {
                oneofKind: "actionReference",
                actionReference: option.actionReference,
              },
            },
          };
        }

        return {
          oneofKind: "recordList",
          recordList: {
            recordList: {
              oneofKind: "actionReference",
              actionReference: option.actionReference,
            },
            ...recordListConfigFrom(currentAction.description.recordListOutput),
          },
        };
      }
      if (isLoopingOutputAction(currentAction)) {
        return {
          oneofKind: "outputReference",
          outputReference: {
            outputId: "",
            source: {
              oneofKind: "actionReference",
              actionReference: option.actionReference,
            },
          },
        };
      }
      return undefined;
    }
    default:
      return undefined;
  }
};
